(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.hcb-article-page');
    if (!root) return;

    const content = root.querySelector('.blog-post-content');
    const toc = root.querySelector('.hcb-article-toc');
    const tocLinks = root.querySelector('#hcb-article-toc-links');
    if (!content || !toc || !tocLinks) return;

    const usedIds = new Set();
    const headings = Array.from(content.querySelectorAll('h2'))
      .filter((heading) => heading.textContent.trim().length > 2)
      .map((heading) => {
        const label = heading.textContent.trim();
        const base = label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
        let id = base;
        let suffix = 2;
        while (usedIds.has(id)) {
          id = base + '-' + suffix;
          suffix += 1;
        }
        usedIds.add(id);
        heading.id = id;
        return { label, id };
      });

    if (headings.length < 3) return;

    headings.forEach((heading) => {
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.label;
      tocLinks.appendChild(link);
    });
    toc.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
